/**
 *
 * @param layer capa que se quiere exportar
 * @desc Función para obtener todos los atributos de la capa para la url de exportacion
 */
export const generarURLExtension = (layer) => {
  let url = '';
  let atributeText;
  if (layer.getExtension() !== undefined) {
    let extension = layer.getExtension();
    let idExtension = extension.Id;
    if (idExtension === undefined) idExtension = '';
    url += idExtension;
    let geometry = extension.Geometry;
    if (geometry === undefined) geometry = '';
    url += ',' + geometry;
    if (extension.Property !== undefined) {
      if (extension.Property.length !== undefined) {
        for (let y = 0; y < extension.Property.length; y++) {
          let prop = extension.Property[y];
          atributeText = prop.name;
          if (atributeText === undefined) atributeText = '';
          url += ',' + atributeText;
        }
      } else if (extension.Property.name !== undefined) {
        atributeText = extension.Property.name;
        if (atributeText === undefined) atributeText = '';
        url += ',' + atributeText;
      }
    }
  }
  return url;
};

/**
 *
 * @param type formato de exportación
 * @param layer capa que se quiere exportar
 * @desc Función para construir la URL de exportación
 */
export const construirURLExport = (type, layer, taulaFullFilter) => {
  let layerTitle = layer.getTitle();

  let url = {};
  let layerName = layer.getName();
  if (layerName === undefined) layerName = '';
  url.LAYER = layerName;
  url.OUTPUTFORMAT = type;

  let extensionUrl = generarURLExtension(layer);
  if (extensionUrl !== undefined) {
    url.propertyName = extensionUrl;
  }

  if (taulaFullFilter && taulaFullFilter[layerTitle] !== undefined) {
    url.CQL_FILTER = taulaFullFilter[layerTitle];
    url.CQL_FILTER = url.CQL_FILTER.replace(/%25/g, '%');
  }

  return url;
};
